import './Separator.scss';

interface SeparatorProps {
  text: string;
}

export default function Separator({ text }: SeparatorProps) {
  return (
    <div className="separator-text">
      <hr />
      <span>{text}</span>
      <hr />
    </div>
  );
}
